import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { DatasetDetails } from "./routes";

export default store => ({
  path: "datasets",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "admin-datasets" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [DatasetDetails(store)],
});
